import React, { useCallback, useEffect, useRef, useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { CHECKOUT_URL, previewImages } from '../data/atlas';
export function PreviewCarousel() {
  const trackRef = useRef<HTMLUListElement>(null);
  const [index, setIndex] = useState(0);
  const scrollTo = useCallback((i: number) => {
    const track = trackRef.current;
    if (!track) return;
    const clamped = Math.max(0, Math.min(previewImages.length - 1, i));
    const slide = track.children[clamped] as HTMLElement | undefined;
    if (slide) {
      track.scrollTo({
        left: slide.offsetLeft - track.offsetLeft,
        behavior: 'smooth'
      });
    }
  }, []);
  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;
    const onScroll = () => {
      const width = track.clientWidth;
      if (width === 0) return;
      setIndex(Math.round(track.scrollLeft / width));
    };
    track.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => track.removeEventListener('scroll', onScroll);
  }, []);
  return <section className="bg-navy px-4 py-6 sm:py-8" data-id="element-118" data-mp="3alm3banp8nfl">
      <div className="mx-auto max-w-4xl" data-id="element-119" data-mp="3amezxisy1wk0">
        <p className="text-center text-[10px] font-extrabold uppercase tracking-[0.2em] text-teal sm:text-xs" data-id="element-120" data-mp="3fli4z38xc2rz">
          Preview the material
        </p>
        <h2 className="mt-1 text-center text-2xl leading-none text-white sm:text-3xl" data-id="element-121" data-mp="3kd9o4spr3683">
          Take a Look Inside PROSTHODONTICS VISUAL ATLAS™
        </h2>
        <p className="mx-auto mt-2 max-w-2xl text-center text-sm font-medium leading-snug text-ice" data-id="element-122" data-mp="3tbu2jhoa2tqi">
          Explore the visual maps, clear diagrams, comparisons and study resources included
          inside the complete system.
        </p>

        <div className="relative mt-4" data-id="element-123" data-mp="74ndejxku4t7">
          <ul ref={trackRef} className="no-scrollbar flex snap-x snap-mandatory gap-3 overflow-x-auto scroll-smooth" aria-label="Preview of pages inside the Visual Atlas" data-id="element-124" data-mp="23xyqnzo1z526">
            {previewImages.map(image => <li key={image.src} className="w-full shrink-0 snap-center" data-id="element-125" data-mp="20y6oa1ku1579">
                <a href={CHECKOUT_URL} className="block" data-id="element-126" data-mp="1vyk8bkdmdaur">
                  <img src={image.src} alt={image.alt} loading="lazy" className="mx-auto w-full rounded-lg border-2 border-ice bg-white shadow-2xl" data-id="element-127" data-mp="2aut60hhv3g52" />
                </a>
              </li>)}
          </ul>

          <button type="button" onClick={() => scrollTo(index - 1)} disabled={index === 0} aria-label="Previous page" className="absolute left-1 top-1/2 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full bg-white/95 text-navy shadow-lg transition-colors duration-150 hover:bg-teal hover:text-white disabled:pointer-events-none disabled:opacity-0" data-id="element-128" data-mp="2ewn0u95dlpxb">
            <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-129" data-mp="2yhrjd6aoq7yr" />
          </button>
          <button type="button" onClick={() => scrollTo(index + 1)} disabled={index === previewImages.length - 1} aria-label="Next page" className="absolute right-1 top-1/2 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full bg-white/95 text-navy shadow-lg transition-colors duration-150 hover:bg-teal hover:text-white disabled:pointer-events-none disabled:opacity-0" data-id="element-130" data-mp="3h8xziyg02ibp">
            <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-131" data-mp="338n73qz1kvof" />
          </button>
        </div>

        <div className="mt-3 flex items-center justify-center gap-2" data-id="element-132" data-mp="2phrwoa8wa6iq">
          {previewImages.map((image, i) => <button key={image.src} type="button" onClick={() => scrollTo(i)} aria-label={`Go to page ${i + 1} of ${previewImages.length}`} aria-current={i === index} className={`h-2 rounded-full transition-[width,background-color] duration-200 ease-soft ${i === index ? 'w-6 bg-teal' : 'w-2 bg-white/40 hover:bg-white/70'}`} data-id="element-133" data-mp="2tjdg6efxpj1w" data-mpi={i} />)}
        </div>

        <CTAButton className="mx-auto mt-4 max-w-md" data-id="element-134" data-mp="3e26wj38g6wrb">
          🦷 YES! I WANT THE COMPLETE SYSTEM
        </CTAButton>
      </div>
    </section>;
}